<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import {doShow as showAlert} from "src/components/cabinet/#common/alert/store"
    import {lockUp} from 'src/components/cabinet/#services/vesting'
    import {myRole} from "src/components/#common/myRole"
    import {delay} from "src/global/delay";

    let loading = false
    let pool = 1
    let wallets
    let amount
    let interval
    let quantity
    let onlyOnce = false
    const minuteInMilliseconds = 60000

    function getInterval() {
        if (quantity && interval) {
            if (interval == 'i') {
                return +quantity * minuteInMilliseconds
            } else if  (interval == 'h') {
                return +quantity * 60 * minuteInMilliseconds
            } else if  (interval == 'd') {
                return +quantity * 60 * 24 * minuteInMilliseconds
            } else if (interval == 'w') {
                return +quantity * 60 * 24 * 7 * minuteInMilliseconds
            } else if (interval == 'm') {
                return +quantity * 60 * 24 * 30 * minuteInMilliseconds
            }
        }
    }

    async function lockUpHandler() {
        try {
            loading = true

            await lockUp.request({ data: {
                wallets: wallets.split("\n").filter(e => e).map(e => e.trim()),
                quantity: +quantity,
                interval: getInterval().toString(),
                poolId: pool,
                onlyOnce,
                amount
            }})

            await delay(500)

            wallets = ''
            amount = ''
            quantity = ''

            showAlert.set({
                status: 'success',
                text: 'Successfully locked'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            loading = false
        }
    }
</script>

<svelte:head>
    <title>Vesting</title>
</svelte:head>

<MainLayout title="Vesting">
    <svelte:fragment slot="content">
        {#if $myRole.hasValue && $myRole?.value?.name === 'SuperAdmin'}
            <div class="row">
                <div class="col-lg-7">
                    <div class="card card-body">
                        <label>Pool</label>
                        <select class="form-select mb-3" bind:value={pool}>
                            <option value={1}>...7f611 - Game Operation</option>
                            <option value={2}>...470cf - Marketing Fund</option>
                            <option value={3}>...11e3e - Ecosystem</option>
                            <option value={4}>...f83c0 - Validators</option>
                            <option value={5}>...1db0f - Liquidity</option>
                            <option value={6}>...f7fc3 - Advisors</option>
                            <option value={7}>...20a1f - Team</option>
                            <option value={8}>...fd646 - Company Reserve</option>
                            <option value={9}>...91ee8 - Seed Sale</option>
                            <option value={10}>...5c3c0 - Community</option>
                        </select>
                        <label>Wallet address</label>
                        <textarea class="form-control mb-3" bind:value={wallets} placeholder="Enter wallets"></textarea>
                        <label>Amount</label>
                        <input type="text" class="form-control mb-3" bind:value={amount} placeholder="Enter Amount">
                        <label>Time period</label>
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" bind:value={quantity} placeholder="Enter quantity">
                            <select class="form-select" bind:value={interval}>
                                <option value="i">minutes</option>
                                <option value="h">hours</option>
                                <option value="d">days</option>
                                <option value="w">weeks</option>
                                <option value="m">months</option>
                            </select>
                        </div>
                        <div class="input-group mb-3">
                            <label class="cursor-pointer">
                                <input type="checkbox" class="form-check-input" bind:checked={onlyOnce}>
                                <span class="pl-3">Only once</span>
                            </label>
                        </div>
                        <button class="btn btn-primary" on:click={lockUpHandler} class:loading={loading}
                            disabled={loading || (!wallets || !amount || !quantity)}>Lock up</button>
                    </div>
                </div>
            </div>
        {/if}
    </svelte:fragment>
</MainLayout>

<style>
    textarea {
        min-height: 100px;
    }

    .pl-3 {
        padding-left: 7px;
    }

    .cursor-pointer {
        cursor: pointer;
    }
</style>
